export const DESKTOP_NAV_HEIGHT = '62px';
export const MOBILE_NAV_HEIGHT = '66px';

export const EST = 'America/New_York';
export const PDT = 'America/Los_Angeles';
export const MDT = 'America/Denver';
